import axios from 'axios';

// API 基础配置统一收口在此，baseURL 可通过 .env 的 VUE_APP_* 变量覆盖
export const xzsApi = axios.create({
  baseURL: process.env.VUE_APP_XZS_API || 'https://xzs.lbzuche.cn',
  timeout: 15000,
});

export const lifeApi = axios.create({
  baseURL: process.env.VUE_APP_LIFE_API || 'https://life.greenbaytrip.com:8080',
  timeout: 15000,
});
